// @ts-check

/**
 * Custom element for the in-store accordion.
 *
 * @class
 * @extends HTMLElement
 */
class InStoreAccordion extends HTMLElement {
  constructor() {
    super()

    /** @type {HTMLDetailsElement | null} The details element */
    this.detailsElement = this.querySelector('details')

    /** @type {ProductDeliveryOptionsCustom | null} The product delivery options custom element */
    this.productDeliveryOptionsCustom = null

    /** @type {ProductClickAndCollectCustom | null} The click and collect custom element */
    this.clickAndCollectCustom = null

    /** @type {HTMLAnchorElement | null} The store link element */
    this.storeLinkElement = null
  }

  connectedCallback() {
    this.setHtmlElements()
    this.setEventListeners()
  }

  setHtmlElements() {
    const productDeliveryOptionsCustom = document.querySelector('product-delivery-options-custom')
    if (productDeliveryOptionsCustom) {
      this.productDeliveryOptionsCustom = productDeliveryOptionsCustom
    }

    const clickAndCollectCustom = document.querySelector('product-click-and-collect-custom')
    if (clickAndCollectCustom) {
      this.clickAndCollectCustom = clickAndCollectCustom
    }

    const storeLinkElement = this.querySelector('[data-component-in-store-accordion-link]')
    if (storeLinkElement instanceof HTMLAnchorElement) {
      this.storeLinkElement = storeLinkElement
    }
  }

  setEventListeners() {
    this?.detailsElement?.addEventListener('toggle', () => {
      if (this?.detailsElement?.open) {
        this.productDeliveryOptionsCustom?.close()
        this.clickAndCollectCustom?.close()
      }
    })
  }

  set storeLink(link) {
    if (this.storeLinkElement) {
      this.storeLinkElement.href = link
    }
  }

  close() {
    this.detailsElement?.removeAttribute('open')
  }
}

customElements.define('in-store-accordion', InStoreAccordion)
